<template>
  <UIInputText
    placeholder="Global search"
    size="sm"
    readonly
    class="mobile-footer-search-input"
    @click="handleOpen"
  >
    <template #trailing>
      <MagnifyingGlassIcon aria-hidden="true" />
    </template>
  </UIInputText>
</template>

<script setup lang="ts">
import { markRaw } from 'vue'

import { useModalsStore } from '@/store/modals'

import { MagnifyingGlassIcon } from '@heroicons/vue/24/outline'
import { UIInputText } from '@ui/fields'
import MoreSearchPanel from './MoreSearchPanel.vue'

const modalsStore = useModalsStore()


const handleOpen = () => {
  const modalInstance = modalsStore.init(
    'mobile-footer-more-search',
    markRaw(MoreSearchPanel),
  )
  modalInstance?.open(modalsStore.getZIndex())
}
</script>

<style>
.mobile-footer-search-input {
  @apply flex-auto;
  @apply cursor-pointer;
}
</style>
